const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const NewsAdd = () => import(/* webpackChunkName: "news" */ '@/modules/news/view/add.vue');
const NewsContent = () => import(/* webpackChunkName: "news" */ '@/modules/news/view/content.vue');
const NewsEdit = () => import(/* webpackChunkName: "news" */ '@/modules/news/view/edit.vue');
const NewsList = () => import(/* webpackChunkName: "news" */ '@/modules/news/view/index.vue');
const NewsTranslate = () => import(/* webpackChunkName: "news" */ '@/modules/news/view/translate.vue');

export const ROUTE_NAME_NEWS = {
    INDEX: 'NewsList',
    ADD: 'NewsAdd',
    CLONE: 'NewsClone',
    EDIT: 'NewsEdit',
    CONTENT: 'NewsContent',
    TRANSLATE: 'NewsTranslate'
} as const;

export default [
    {
        path: '/app/:appId/news',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_NEWS.INDEX,
                component: NewsList,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/edit',
                name: ROUTE_NAME_NEWS.EDIT,
                component: NewsEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/content',
                name: ROUTE_NAME_NEWS.CONTENT,
                component: NewsContent,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_NEWS.ADD,
                component: NewsAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/clone',
                name: ROUTE_NAME_NEWS.CLONE,
                component: NewsAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/translate',
                name: ROUTE_NAME_NEWS.TRANSLATE,
                component: NewsTranslate,
                meta: { requiresAuth: true }
            }
        ]
    }
];
